import { Action } from "@pilatestime/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAccessProfileQueryOptions } from "@/api/accessProfile";
import { can } from "@/hooks/useAccessControl";
import { useApiParameters } from "@/hooks/useApiParameters";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/org-management/",
)({
	beforeLoad: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const orgId = params.orgId;

		const profile = await context.queryClient.ensureQueryData(
			fetchAccessProfileQueryOptions(userId, token, orgId),
		);

		if (can(profile, Action.VIEW_FINANCIAL_ANALYSIS)) {
			throw redirect({
				to: "/app/org/$orgId/org-management/financial-analysis",
				params: { orgId },
			});
		}

		if (can(profile, Action.VIEW_CUSTOMER_RISK_ANALYSIS)) {
			throw redirect({
				to: "/app/org/$orgId/org-management/customer-risk-analysis",
				params: { orgId },
			});
		}

		if (can(profile, Action.VIEW_COST_MANAGEMENT)) {
			throw redirect({
				to: "/app/org/$orgId/org-management/cost-management",
				params: { orgId },
			});
		}

		throw redirect({ to: "/app/org/$orgId", params: { orgId } });
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <div>You will be redirected.</div>;
}
